var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_21165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2141 13.0093C24.2141 12.0261 24.1343 11.3085 23.9616 10.5645H12.7336V15.0024H19.3242C19.1914 16.1053 18.4739 17.7663 16.8793 18.8824L16.857 19.031L20.407 21.7812L20.653 21.8057C22.9118 19.7195 24.2141 16.6501 24.2141 13.0093Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7336 24.703C15.9624 24.703 18.6731 23.6399 20.653 21.8063L16.8793 18.883C15.8695 19.5872 14.5141 20.0788 12.7336 20.0788C9.57121 20.0788 6.88715 17.9928 5.93035 15.1094L5.79011 15.1213L2.09869 17.9781L2.05042 18.1123C4.01695 22.0188 8.05637 24.703 12.7336 24.703Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93041 15.1099C5.67796 14.3658 5.53185 13.5685 5.53185 12.7447C5.53185 11.9209 5.67796 11.1236 5.91713 10.3796L5.91044 10.2211L2.17276 7.31836L2.05047 7.37653C1.23997 8.99763 0.774902 10.8181 0.774902 12.7447C0.774902 14.6714 1.23997 16.4918 2.05047 18.1129L5.93041 15.1099Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7336 5.40919C14.9792 5.40919 16.4939 6.37917 17.3577 7.18977L20.7327 3.89444C18.6599 1.96775 15.9624 0.785156 12.7336 0.785156C8.05637 0.785156 4.01695 3.46922 2.05042 7.37572L5.91707 10.3787C6.88715 7.49535 9.57121 5.40919 12.7336 5.40919Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_21165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4504,
    height: 24,
    fill: "white",
    transform: "translate(0.77478 0.785156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuth);
export default __webpack_public_path__ + "static/media/google-auth.4cc671372e14edae6e1158924a100438.svg";
export { ForwardRef as ReactComponent };